import * as types from '@/store/types/global.types';

export default {
  namespaced: true,
  state: {
    visible: false,
    message: null,
  },
  getters: {
    error: state => ({ visible: state.visible, message: state.message }),
  },
  mutations: {
    [types.SET](state, payload) {
      const nextState = { ...state, message: payload.message, visible: true };
      console.log(nextState);
      state = nextState;
    },
    [types.HIDE](state) {
      state.visible = false;
    },
  },
  actions: {
    setError({ commit }, payload) {
      commit(types.SET, payload);
    },
    hideError({ commit }) {
      commit(types.HIDE);
    },
  },
};
